import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  fullSize: {
    width: "100%",
    height: "100%",
  },
}));
